import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const registerGameficationScore = async ({
  type,
  studentId = _cookies.getItem("auth").user.alunoid,
  details = "",
  multiplier = 1,
  ref,
}) => {
  const body = new FormData();
  body.append(
    "dados",
    `[${JSON.stringify({
      pTAG_SCORE: type,
      alunoid: studentId,
      detalhes: details,
      multiplicador: multiplier,
      ref,
    })}]`
  );

  const res = await axios.middleware.post("/aluno.asmx/SalvaPontuacao", body);
  return res[0].data;
};

export const useRegisterGameficationScore = ({ config, courseId } = {}) => {
  return useMutation({
    ...config,
    mutationFn: registerGameficationScore,
  });
};
